module.exports = __webpack_public_path__ + "media/seeYouSoon2.bb81f993.mp3";